/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    "use strict";
    /**
     * <h3>折叠菜单</h3>
     * <a href="../../ui_controls/bui.accordion.html" target="_blank">demo</a>
     * <p>折叠菜单初始化时尽量使用ID单独初始化,它不止可以用于dl,dt 这样的结构,还可以用在panel以及自定义的结构中,更多例子参考modules/accordion_panel.html</p>
     * {{#crossLink "bui.accordion/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.accordion/widget"}}{{/crossLink}}: 获取依赖的控件 <br>
     * {{#crossLink "bui.accordion/show"}}{{/crossLink}}: 展开第几个 <br>
     * {{#crossLink "bui.accordion/hide"}}{{/crossLink}}: 隐藏第几个 <br>
     * {{#crossLink "bui.accordion/showFirst"}}{{/crossLink}}: 所有折叠菜单显示第一个<br>
     * {{#crossLink "bui.accordion/showAll"}}{{/crossLink}}: 所有折叠菜单全部展开 <br>
     * {{#crossLink "bui.accordion/hideAll"}}{{/crossLink}}: 所有折叠菜单全部隐藏 <br>
     *  @namespace bui
     *  @class accordion
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]  
     *  @param {string} [option.handle] [点击的区域]  
     *  @param {number} [option.height] [父层高度,0则自适应]  
     *  @param {string} [option.target] [要显示隐藏的目标]  
     *  @param {number} [option.targetHeight] [目标自适应高度还是限制高度]  
     *  @param {boolean} [option.single] [ false(显示多个) || true(一次只折叠一个) ] 
     *  @param {function} [option.callback] [ 点击按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <dl id="accordion">
                <dt class="bui-btn">折叠菜单</dt>
                <dd>
                    折叠菜单的内容
                </dd>
            </dl>
     *      
     *   js: 
     *   
            // 初始化
            var uiAccordion = bui.accordion({ 
                id: "#accordion"
              });
      
            // 展开第一个
            uiAccordion.showFirst();
     *
     */
    ui.accordion = function(option){

        var config = {
            id: "",        
            handle: "dt",  
            target: "dd",  
            height: 0,     
            targetHeight: 0, 
            single:false,  
            callback:null
        }
        //方法
        var module = {
            showFirst: showFirst,
            showAll: showAll,
            hideAll: hideAll,
            show: show,
            hide: hide,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true, {},config, ui.config.accordion, option );

        var $id,
            id,
            el,
            winWidth,
            winHeight,
            $handle,
            $target;
        
        //执行初始化
        init(param);
        
        //初始化
        function init (option) {
            option = option || param;
            // 屏幕的宽度
            winWidth  = document.documentElement.clientWidth; 
            winHeight = document.documentElement.clientHeight; 

            //验证id
            $id = ui.obj( option.id ) || $('.'+ui.prefix('accordion') );

            //option获取新参数使用
            param = module.config = option;

            //dt
            $handle = $id.children( option.handle );
            //dd
            $target = $id.children( option.target );
            
            //初始化显示
            display(option);
            //绑定事件
            bind(option);

            return this;
        }

        //初始化显示,例如高度,例如是否一次显示一个,还是多个
        function display (option) {

            $target.css("display","none");

            var wrapHeight = winHeight - $("header").height() - $("footer").height();
            //初始化固定高度
            if( parseFloat( option.targetHeight ) > 0 ){
                $target.height( option.targetHeight);
            }
            //初始化父层高度
            if( parseFloat(option.height) > 0 ){
                $id.height( option.height );
            }

        }
        //绑定事件
        function bind (option) {
            
            $id.off("click.bui",option.handle).on("click.bui",option.handle,function (e) {
                var self = this;

                toggle(self,option);

                option.callback && option.callback.call(this,module);

            })
        }

        //切换器
        function toggle (self,option) {

            var isActive = $(self).hasClass('active');
            var target = $(self).next( option.target ); 
            //默认展开多个
            if( !option.single ){
                if( isActive ){
                    $(self).removeClass('active');
                    target.css("display","none");

                }else{
                    $(self).addClass('active');
                    target.css("display","block");
                }
            }else{
                //一次只展开一个
                if( isActive ){
                    $handle.removeClass('active');
                    $target.css("display","none");
                }else{
                    $(self).addClass('active')
                        .siblings( option.handle ).removeClass('active');

                    target.css("display","block")
                        .siblings( option.target ).css("display","none");
                }
            }
        }

        /**
         * 显示第几个面板 这个需要绑定ID单独显示
         *  @method show
         *  @chainable
         *  @param {number} [index] [显示第几个,从0开始算起]
         *  @example 
            
            //显示第几个
            uiAccordion.show(1);
                
         */
        function show (index) {
            var index = Number(index) || 0;
            
            $handle.each(function (i,item) {

                if( i == index ){
                    $(this).addClass('active')
                              .next( param.target ).css("display","block");
                }
            })

            return this;
        }


        /**
         * 关闭第几个面板 这个需要绑定ID单独显示
         *  @method hide
         *  @chainable
         *  @param {number} [index] [关闭第几个,从0开始算起]
         *  @example 
            
            //显示第几个
            uiAccordion.hide(1);
                
         */
        function hide (index) {
            var index = Number(index) || 0;
            
            $handle.each(function (i,item) {

                if( i == index ){
                    $(item).removeClass('active')
                               .next( param.target ).css("display","none");
                }
            })
            return this;

        }

        /**
         * 所有折叠菜单显示第一个
         *  @method showFirst
         *  @chainable
         *  @example 
            
            //显示第几个
            uiAccordion.showFirst();
                
         */
        function showFirst () {
            if( $id.length > 1 ){
                $id.each(function(index, el) {
                    $(el).children( param.handle ).eq(0).trigger('click');
                });
            }else{
                $id.children( param.handle ).eq(0).trigger('click');
            }
            

            return this;
        }

        /**
         * 显示所有隐藏的菜单
         *  @method showAll
         *  @chainable
         *  @example 
            
            //显示第几个
            uiAccordion.showAll();
                
         */
        function showAll () {
            
            $handle.each(function (i,item) {

                $(item).addClass('active')
                              .next( param.target ).css("display","block");
            })
            return this;

        }

        /**
         * 隐藏所有展开的菜单
         *  @method hideAll
         *  @chainable
         *  @example 
            
            //隐藏第几个
            uiAccordion.hideAll();
                
         */
        function hideAll () {
            
            $handle.each(function (i,item) {

                $(item).removeClass('active')
                              .next( param.target ).css("display","none");
            })
            return this;

        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiAccordionWidget = uiAccordion.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
            var option = uiAccordion.option();

            //获取某个参数
            var id = uiAccordion.option( "id" );

            //修改一个参数
            uiAccordion.option( "height",200 );

            //修改多个参数
            uiAccordion.option( {"height":200} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        
        return module;
    };


    return ui;

})( bui || {}, libs );
